import React, { FC } from 'react';
import { Modal, Row, Col, Form } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';
import moment from 'moment';
import { showError } from '../../../../helpers/api/api';
import { getValidator } from '../../../../helpers/validator';
import InputBaht from '../../common/InputBaht';
import { Store } from 'antd/lib/form/interface';
import { onFinishFailedHandler } from '../../../../helpers/form';
import { ErrorInfo } from '../../../../types/form-types';
import { datediff } from '../../../../helpers/date/date';

const calculateOsb = (intRate: number, lastTransaction: any) => {
  const asOfDate = moment().format('YYYY-MM-DD');
  const { cfPrincipal, cfInterest, cfFee } = lastTransaction;
  const principal = cfPrincipal / 100;
  const duration = datediff(asOfDate, lastTransaction.transDate);
  const dueInterest = ((cfPrincipal * intRate) / 365) * duration;
  const interest = (cfInterest + dueInterest) / 100;
  const fee = cfFee / 100;
  const total = principal + interest + fee;
  return {
    asOfDate,
    total: total.toFixed(2),
    principal: principal.toFixed(2),
    interest: interest.toFixed(2),
    fee: fee.toFixed(2),
  };
};
interface Props {
  visible: boolean;
  onCancel: () => void;
  cancelText: string;
  okText: string;
  intRate: number;
  transaction: any;
  setQrAmount: any;
  setqrcodePaymentModalVisible: any;
}

const GenQrcodeModal: FC<Props> = ({
  visible,
  onCancel,
  cancelText,
  okText,
  intRate,
  transaction,
  setQrAmount,
  setqrcodePaymentModalVisible,
}) => {
  const [form] = Form.useForm();
  const intl = useIntl();
  let availableLimit: any = 1;
  if (transaction) {
    availableLimit = calculateOsb(intRate, transaction).total;
  }

  const onFinish = async (value: Store) => {
    try {
      setQrAmount(value.amount);
      onCancel();
      setqrcodePaymentModalVisible(true);
    } catch (error) {
      form.resetFields();
      showError(error);
    }
  };
  const onFinishFailed = (errorInfo: ErrorInfo) => {
    onFinishFailedHandler(intl, 'common.inputvalidation-failed', errorInfo);
  };

  return (
    <Modal
      visible={visible}
      cancelText={cancelText}
      width="700px"
      onCancel={onCancel}
      cancelButtonProps={{ type: 'primary', ghost: true }}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        initialValues={{ amount: Number(transaction.minDue).toFixed(0) }}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <h2>
            <FormattedMessage id="qrcode" />
          </h2>
        </Row>
        <hr />
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label={intl.formatMessage(
                { id: 'withdraw.maxamount' },
                { maxAmount: intl.formatNumber(availableLimit) },
              )}
              name="amount"
              rules={[
                { required: true },
                { validator: getValidator(intl, 'maxBathAmount', { maxAmount: availableLimit }) },
                { validator: getValidator(intl, 'minBathAmount', { minAmount: 1 }) },
              ]}
            >
              <InputBaht />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default GenQrcodeModal;
